export const OPEN_PRIMARY = "OPEN_PRIMARY";
export const OPEN_SECONDARY = "OPEN_SECONDARY";
export const CLOSE_PRIMARY = "CLOSE_PRIMARY";
export const CLOSE_SECONDARY = "CLOSE_SECONDARY";
export const EXPAND_SECONDARY = "EXPAND_SECONDARY";
export const SHRINK_SECONDARY = "SHRINK_SECONDARY";
export const UPDATE_VIEWING_HISTORY = "UPDATE_VIEWING_HISTORY";
export const SET_SELECTED_CONTEXT = "SET_SELECTED_CONTEXT";
export const CLEAR_SELECTED_CONTEXT = "CLEAR_SELECTED_CONTEXT";
export const CLEAR_VIEWING_HISTORY = "CLEAR_VIEWING_HISTORY";
